import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccessDeniedComponent, ExternalRedirectComponent, KeycloakAuthComponent} from '@twpub/shared/components';
import {ResultPageWrapperComponent, SearchPageWrapperComponent} from '@twpub/shared/components/wrappers';
import {ClientConfigurationResolver} from '@twpub/core/utils/ClientConfigurationResolver';
import {AuthGuard} from '@twpub/shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'auth/keycloak',
    component: KeycloakAuthComponent
  },
  {
    path: 'admin',
    loadChildren: () =>
      // todo imported routes are not working with SSR
      import('./admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'superadmin',
    loadChildren: () =>
      import('./superadmin/superadmin.module').then((m) => m.SuperadminModule)
  },
  {
    path: 'dict/:dictId/:cid/:tid',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: SearchPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  },
  {
    path: 'dict/:cid/:tid',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: SearchPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  },
  {
    path: 'dict/:cid',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: SearchPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  },
  {
    path: 'dict',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: SearchPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  },
  {
    path: 'result/:cid/:tid',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: ResultPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  },
  {
    path: 'external/:url',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: ExternalRedirectComponent
  },
  {
    path: '',
    canActivate: [AuthGuard],
    data: {requiredGroups: ['search']},
    component: SearchPageWrapperComponent,
    resolve: {clientConfig: ClientConfigurationResolver}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // enabledNonBlocking required to stop Keycloak loop on log in.
    // see https://github.com/mauriciovigolo/keycloak-angular/issues/289
    initialNavigation: 'enabledNonBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
